import { METHOD } from './method'

export const API_GIFT = {
    LIST: {
        api: '/v1/dashboard-admin/gift/list',
        method: METHOD.POST,
    },
    EXPORT: {
        api: '/v1/dashboard-admin/gift/list/export',
        method: METHOD.POST,
    },
    BULK_ACTION: {
        api: '/v1/dashboard-admin/gift/bulk-action',
        method: METHOD.POST,
    },
    DETAIL: {
        api: '/v1/dashboard-admin/gift',
        method: METHOD.GET,
    },
    URL_GIFT_IMAGE: {
        api: '/v1/dashboard-admin/gift/storage-url/attachment',
        method: METHOD.POST,
    },
    CREATE: {
        api: '/v1/dashboard-admin/gift',
        method: METHOD.POST,
    },
    UPDATE: {
        api: '/v1/dashboard-admin/gift',
        method: METHOD.PUT,
    },
    DRAFT: {
        api: '/v1/dashboard-admin/gift/draft',
        method: METHOD.PUT,
    },
}
